/* In-page section indication. Native links and details work without JavaScript. */
if (!customElements.get('brand-editorial')) {
  customElements.define('brand-editorial', class extends HTMLElement {
    connectedCallback() {
      this.links = [...this.querySelectorAll('.il-brand-index a')];
      this.sections = this.links.map(link => this.querySelector(link.getAttribute('href'))).filter(Boolean);
      this.update = () => {
        const target = [...this.sections].reverse().find(section => section.getBoundingClientRect().top <= 220) || this.sections[0];
        this.links.forEach(link => {
          if (target && link.hash === '#' + target.id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
